export const LOADING_STARTED = "LOADING_STARTED"
export const loadingStartedAction = ()=> ({
    type: LOADING_STARTED
})

export const LOADING_ENDED = "LOADING_ENDED"
export const loadingEndedAction = ()=> ({
    type: LOADING_ENDED
})